export function scrambleTextEffect (element, finalText, duration = 1000) {
  const chars = '!<>-_\\/[]{}—=+*^?#________'
  const letters = String(finalText).split('')
  const startTime = performance.now()
  let isStopped = false

  function animate (now) {
    if (isStopped) {
      element.innerHTML = finalText
      return
    }

    const elapsed = now - startTime
    const progress = Math.min(elapsed / duration, 1)

    const displayText = letters.map((letter, i) => {
      if (i < progress * letters.length) {
        return letter
      } else {
        return chars[Math.floor(Math.random() * chars.length)]
      }
    })

    element.innerHTML = displayText.join('')

    if (progress < 1) {
      requestAnimationFrame(animate)
    } else {
      element.innerHTML = finalText
    }
  }

  requestAnimationFrame(animate)

  return {
    stop () {
      isStopped = true
    }
  }
}

export function unscrambleTextEffect (element, finalText, duration = 1000) {
  const chars = '!<>-_\\/[]{}—=+*^?#________'
  const letters = String(finalText).split('')
  const startTime = performance.now()
  let isStopped = false

  function animate (now) {
    if (isStopped) {
      element.innerHTML = ''
      return
    }

    const elapsed = now - startTime
    const progress = Math.min(elapsed / duration, 1)

    const displayText = letters.map((letter, i) => {
      if (i > progress * letters.length) {
        return letter
      } else {
        return chars[Math.floor(Math.random() * chars.length)]
      }
    })

    element.innerHTML = displayText.join('')

    if (progress < 1) {
      requestAnimationFrame(animate)
    } else {
      // 最後清掉
      element.innerHTML = ''
    }
  }

  requestAnimationFrame(animate)

  return {
    stop () {
      isStopped = true
    }
  }
}
